import React from 'react'
import PropTypes from 'prop-types'
import formatDay from './formatDay'
import { cardModel } from './cardModel'
import { bureauName, ALL_REPORTS, REPORT_DATE, NO_SCORE, NO_REPORT, MODEL_NOT_REPORTED } from './copy'

const AllReportsTable = ({ rows, bureaus, wide = false }) => {
  const cardModels = Object.fromEntries(bureaus.map((entry) => [entry.bureau, cardModel(entry)]))

  const renderCell = (bureau, cell) => {
    if (!cell) return NO_REPORT
    if (cell.score === null || cell.score === undefined) return NO_SCORE
    const model = cell.model ?? null
    if (model === cardModels[bureau]) return String(cell.score)
    return (
      <>
        {`${cell.score} `}
        <span className="block whitespace-nowrap text-xs text-text-secondary">({model || MODEL_NOT_REPORTED})</span>
      </>
    )
  }

  return (
    <div
      data-testid="all-reports"
      className={`min-w-0 overflow-hidden rounded-2xl border border-divider bg-surface shadow-subtle dark:shadow-none${wide ? ' md:col-span-2' : ''}`}
    >
      <p className="m-0 px-5 pb-3 pt-4 text-md font-semibold text-text-primary">{ALL_REPORTS}</p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-left tabular-nums">
          <thead>
            <tr className="bg-[var(--color-bg-subtle)]">
              <th className="px-3.5 py-2.5 text-[13px] font-semibold text-text-secondary">{REPORT_DATE}</th>
              {bureaus.map((entry) => (
                <th key={entry.bureau} className="px-3.5 py-2.5 text-right text-[13px] font-semibold text-text-secondary">
                  {bureauName(entry.bureau)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.day}>
                <td className="whitespace-nowrap border-t border-divider px-3.5 py-2.5 text-md text-text-primary">{formatDay(row.day)}</td>
                {bureaus.map((entry) => (
                  <td key={entry.bureau} className="whitespace-nowrap border-t border-divider px-3.5 py-2.5 text-right text-md text-text-primary">
                    {renderCell(entry.bureau, row.cells[entry.bureau])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

AllReportsTable.propTypes = {
  rows: PropTypes.array.isRequired,
  bureaus: PropTypes.array.isRequired,
  wide: PropTypes.bool,
}

export default AllReportsTable
